import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { ApidataService } from "../apidata.service";
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-account-activation-phone',
  standalone: true,
  imports: [ HttpClientModule, CommonModule],
  templateUrl: './account-activation-phone.component.html',
  styleUrl: './account-activation-phone.component.css'
})
export class AccountActivationPhoneComponent {


  endRequest;
  sub;
  id;
  data;


  constructor(
    private route: ActivatedRoute,
    private router: Router,   private apiService: ApidataService,
    private httpClient: HttpClient) { }


    ngOnInit() {
      window.scroll(0, 0);
     this.route.params.subscribe(params => {
        this.authenticate(params['query1'])       
        localStorage.clear();
      });
    }


  authenticate(conf_code) {

    this.endRequest =
    this.apiService.confirmEmailPhone(conf_code)
      .subscribe(
        data => {
         this.data =data['response'];
          // console.log(data['response'].Invalid_Code_message)
        
          if(data['code'] === 200 || data['response'].confirmation_message){

        
          this.showSuccess("Your account has been successfully verified", "");
        
          setTimeout(() => {
            this.router.navigate(['/signin']);
          }, 2000);
        }
        else if(data['response'].Already_confirmed_message){

          this.router.navigate(['/signin']);

          this.showAlert("You already have confirmed your account", "");

          setTimeout(() => {
            this.router.navigate(['/signin']);
          }, 2000);
        }
        else if(data['response'].Invalid_Code_message){
          this.router.navigate(['/signin']);

          this.showAlert("Sorry Invalid Confirmation Code", "");


          setTimeout(() => {
            this.router.navigate(['/signin']);
          }, 2000);
        }
      },
      error => {
        if (error.status == 403) {

            this.showAlert("Your account has already been activated", "");

          setTimeout(() => {
            this.router.navigate(['/signin']);
          }, 2000);
        }
        else if (error.status === 400) {

    this.showAlert("Please provide all parameters", "");
  }
  setTimeout(() => {
    this.router.navigate(['/signin']);
  }, 2000);
      }
      );
  }
  ngOnDestroy() {
  }

  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;

  showAlert(message, selector) {


    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts;').show();
    setTimeout(() => {
      $('#errorAlerts;').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
    let backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
    }
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false; 
  }

  }

